import React from 'react'
import '../styles/article.css'

const EchoesCH11 = () => {
    return (
        <div className='echoes-chapter'>
            <h1 className='ec-h1'>Chapter 11: Snowballs and Secrets</h1>

            <p>The wind nipped at our cheeks as Cora and I marched briskly down the
                snow-covered block, the kind of chill that made you grateful for every layer you’d
                remembered to put on. The world around us was quiet, muffled by the thick blanket
                of snow falling steadily from the sky. We were lost in our own hurried pace
                when—smack!—a snowball hit me squarely on the back. Another one grazed Cora’s
                shoulder.</p>
            <p>We spun around, startled, only to see Barbara standing a few feet back, a
                mischievous grin on her face and two more snowballs already packed and ready to
                launch. She hollered through the snow, “Slow down! It’s a trio, not a duet, and you
                don’t want to leave the Black girl behind!”</p>
            <p>Cora and I couldn’t help but laugh, though we raised our hands in surrender. We
                waited until Barbara caught up, and then the three of us linked arms for the final
                half block to the hotel, the snow crunching under our boots and the glow of the
                streetlights illuminating the storm.</p>

            <p>“Got drinks in the room?” Barbara asked as we reached the lobby.</p>
            <p>“No,” I admitted, “but there’s a coffee maker.”</p>
            <p>Cora perked up. “A good cup of coffee sounds great right now.”</p>

            <p>Barbara smirked and said, “Hey, Miss Iowa, stick with me for a bit. Miss Indiana,
                what’s your room number?”</p>
            <p>“Twenty-second floor,” I replied, “Ambassador Suite at the end of the hall. Go left
                when you get off the elevator.”</p>
            <p>Barbara nodded. “We’ll be up in five.”</p>

            <p>I stepped into the elevator, turning to face them as the doors began to close. “And
                remember,” I called out, grinning, “we’re a trio, not a duet.”</p>
            <p>As the elevator ascended, I could hear Barbara’s voice trailing off behind me. “Did
                you see how deep that snow is?”</p>
            <p>“Not really,” Cora replied. “I was busy dodging snowballs.”</p>


            <p>“It’s over two feet and still snowing. We might be stuck here for a few days,” Barbara
                said, her tone half-excited, half-concerned. “We need a plan.”</p>
            <p>Cora gave a small shrug. “You might be right, but I live seventy days a year in the
                snow. This is nothing new.”</p>
            <p>“Alright, Miss Frost,” Barbara teased. “I’m from Mississippi, and we’re lucky if we get
                two inches every five years, so please indulge me.”</p>

            <p>Cora laughed. “You’ve got my attention.”</p>
            <p>Barbara leaned in conspiratorially. “There’s probably only one or two coffee packs in
                Ellen’s room. You go to the front desk and ask for ten.”</p>
            <p>“Sounds like a plan,” Cora agreed.</p>

            <p>“I’m going to raid the vending machine for drinks,” Barbara added, already
                scheming. “We’re going to need them on hand, just in case.”</p>
            <p>Cora peered out the window. “You’re right. We might not be getting out of here
                tomorrow, so I like your plan.”</p>
            <p>Barbara wasn’t one to do things halfway. She emptied the vending machine of its last
                twelve drinks, cramming them into every pocket she had. Meanwhile, Cora
                sweet-talked the front desk into giving her twenty packs of coffee along with
                creamer and sugar. By the time they reached the 22nd floor, both of them looked
                like winter scavengers, pockets bulging with provisions.</p>

            <p>When they knocked on the door of the suite, I opened it to find them unloading
                drinks and coffee like they’d just come back from a supply run.</p>
            <p>“What’s this?” I asked, eyeing the growing pile of beverages and coffee packs.
                Barbara grinned. “Plan B, if needed.”</p>
            <p>We all burst into laughter. The room filled with the kind of warmth that made you
                forget the cold outside. I already had coffee brewing, and the snacks were laid out on
                the counter—enough to feed Tom’s entire show choir, though I hadn’t mentioned
                that yet.</p>


            <p>“I only put out a few things,” I said, gesturing to the fridge. “There’s more in there if
                we need it.”</p>
            <p>As we fixed our plates, Barbara took a bite of my cheese ball and stopped mid-chew.
                “Ellen,” she said, her voice serious, “this is the best cheese ball I’ve ever had.”</p>
            <p>I couldn’t help but smile. “Frank and I spent seven years perfecting that recipe. It’s
                our secret weapon.”</p>

            <p>Cora spread some of the cheese on a cracker and nodded. “Barbara’s right. This is
                incredible.”</p>
            <p>For a moment, we just ate and laughed, the storm outside forgotten. Then, as the
                clock ticked closer to showtime, Barbara stood up, brushing crumbs off her lap. “Just
                a few more bites, ladies, and we’ve got to get moving. Remember, the doors close at
                6:37.”</p>
            <p>I glanced at my phone and gasped. “That gives us sixteen minutes! I’ll call for the
                elevator now. Cora, grab my coat!”</p>

            <p>Barbara stuffed a few chocolate peanut butter balls into her pocket. “These are
                coming with me,” she declared, like a soldier stocking up for battle.</p>
            <p>“Barbara, let’s go!” Cora urged, already halfway down the hall.</p>
            <p>We ran to the elevator, the doors sliding shut just as the snow picked up outside.
                Once we reached the street, the three of us locked arms again, bracing against the
                wind as we trudged through the snow toward the Cadillac Place. The snow swirled
                around us, thick and relentless, but we didn’t stop.</p>

            <p>We burst through the doors at 6:33, just in time to sprint up the stairs and slip into
                our balcony seats as the ushers closed the doors behind us. We were breathless and
                laughing, our cheeks flushed from the cold and the rush.</p>
            <p>The finals were minutes away, and as we settled into our seats, I couldn’t help but
                feel a spark of anticipation. This night, with its snowball fights and secret plans, felt
                like the kind of memory that would stay with me forever—proof that sometimes, it’s
                the unexpected moments that make life truly extraordinary.</p>


        </div>
    )
}

export default EchoesCH11